export const AMPLITUDE_WALLET = 'wallet'
export const AMPLITUDE_LOGIN_COUNT = 'login-count'
export const AMPLITUDE_VIP_TIER_LEVEL = 'VIP Tier'
export const AMPLITUDE_CLICK_PLACE_ORDER_COUNT = 'Click Place Order Count'
export const AMPLITUDE_ATTEMPT_PLACE_ORDER_COUNT = 'Attempt Place Order Count'
export const AMPLITUDE_TRANSFERS_MADE_COUNT = 'Transfers Made Count'
export const AMPLITUDE_ERROR = 'Error'
export const AMPLITUDE_SUCCESS = 'Success'
